<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditReviewPeriod"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="editPerformanceReviewPeriod"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full md:h-auto h-screen overflow-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Edit Performance Setup</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <!-- {{ info }} -->
            <!-- Name -->
            <div class="text-sm">
              <label class="block pb-1">Name</label>
              <input
                v-model="info.Name"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <!-- Start Date -->
            <div class="text-sm">
              <label class="block pb-1">Start Date</label>
              <input
                v-model="info.StartDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <!-- End Date -->
            <div class="text-sm">
              <label class="block pb-1">End Date</label>
              <input
                v-model="info.EndDate"
                required
                type="date"
                :min="info.StartDate"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <!-- Objective Setting Period Deadline -->
            <div class="text-sm">
              <label class="block pb-1">Objective Setting Deadline</label>
              <input
                v-model="info.ObjectiveDeadline"
                :min="info.ObjectiveSettingStartDate"
                :max="info.EndDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <!-- Review Period Deadline -->
            <div class="text-sm">
              <label class="block pb-1">Review Deadline</label>
              <input
                v-model="info.ReviewDeadline"
                :min="info.ReviewStartDate"
                :max="info.EndDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "EditReviewPeriod",
  props: ["showEditReviewPeriod", "reload", "info"],
  components: { Loader },
  data() {
    return {
      edit_error: null,
      edit_success: null,
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },

  created() {},
  methods: {
    close() {
      this.$emit("close");
    },

    // /{organization}/setup/document/type/v1/edit
    editPerformanceReviewPeriod() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .put(
          `${this.getOrganization}/performance/period/${this.$ApiVersion}/edit`,
          JSON.stringify({
            ...this.info,
            PerformancePeriodId:this.info.Id
          }),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$notify.success({
                title: "Success",
                message: response.data.StatusMessage,
              });

              this.reload();
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;

            this.$notify.error({ title: "Failure", message: error.message });
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
